<template>
  <div>
    <form class="message__form" @submit.prevent="sendMessage">
      <input
        v-model="message"
        class="message__input"
        type="text"
        :placeholder="$t('Write a message')"
      />
      <IconButton v-if="isPossibleToSend" :height="15" type="submit" :icon="sendButton" />
    </form>
  </div>
</template>

<script>
  import Send from '@/assets/icons/send.svg';
  import IconButton from '@/components/ui/IconButton';

  export default {
    name: 'MessageInput',
    components: {
      IconButton,
    },
    props: {
      placeholder: {
        type: String,
        default: '',
      },
    },
    data() {
      return {
        files: [],
        message: '',
        sendButton: Send,
      };
    },
    computed: {
      isPossibleToSend() {
        return (
          this.message.length || (this.files.length && !this.files.some((file) => file.uploading))
        );
      },
    },
    methods: {
      sendMessage() {
        this.$emit('send', this.message);
        this.message = '';
      },
      uploadFiles(files) {
        files.forEach(this.uploadFile);
      },
      uploadFile(file) {
        this.$emit('upload-file', file);
      },
      deleteFile(idx) {
        this.files.splice(idx, 1);
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import 'src/styles/colors';

  .message__form {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 12px 20px 12px 12px;

    background: white;
    box-shadow: inset 0 1px 0 $grey100, inset 1px 0 0 #dadde2;
  }

  .message-and-files {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    overflow: hidden;
  }

  .message__input {
    margin-left: 12px;
    color: $grey900;
    font-weight: normal;
    font-size: 14px;
  }

  .messages-container {
    padding: 20px;

    overflow: auto;
    max-height: calc(100vh - 200px);
    position: absolute;
    top: 48px;
    width: 100%;
  }

  .message-date {
    text-align: center;
    color: $grey700;
    font-size: 14px;
    padding: 4px 8px;
  }

  .message__attach-files {
    display: flex;
    cursor: pointer;

    &:hover {
      .attach-files__icon path {
        fill: $grey600;
      }
    }
  }

  .attach-files__icon {
    height: 12px;
  }

  .files-container {
    background-color: #ffffff7a;
    padding: 12px;
    display: flex;
  }
</style>
